import { IGioCongDongActionTypes } from './../../action-types/gio-cong-dong/IGioCongDongActionTypes';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { gioCongDongApi } from '../../../api/gioCongDongApi';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eGioCongDongActionTypeIds } from '../../action-types/gio-cong-dong/IGioCongDongActionTypes';
import { actions } from '../../actions/actionsWrapper';
import { IGioCongDong } from '../../../models/response/gio-cong-dong/IGioCongDong';


export function* gioCongDongSaga(): any {
    yield takeLatest(eGioCongDongActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eGioCongDongActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eGioCongDongActionTypeIds.DELETE_START, deleteWorker)

}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(gioCongDongApi.load)
    if (res.is_success) {
        yield put(actions.gioCongDongWrapper.gioCongDong.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.gioCongDongWrapper.gioCongDong.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IGioCongDongActionTypes): any {
    const payload: IGioCongDong = action.payload as IGioCongDong;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(gioCongDongApi.update, payload)
    } else {
        res = yield call(gioCongDongApi.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.gioCongDongWrapper.gioCongDong.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.gioCongDongWrapper.gioCongDong.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IGioCongDongActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(gioCongDongApi.delete, payload)
    if (res.is_success) {
        yield put(actions.gioCongDongWrapper.gioCongDong.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.gioCongDongWrapper.gioCongDong.DELETE_ERROR(res.message ?? "Error"))
    }
}
